export default "__VITE_ASSET__D9htb9qA__"